import * as DomainBaseEntities from "../constants/DomainBaseEntities";
import {areEqual, isAnyEqualToFirst, isEmptyOrNull} from "../common/NamaCommon";
import * as OverrideSelectedDimension from "../constants/OverrideSelectedDimension";
import {isNotNullDimension} from "../common/DimensionsUtil";
import * as FieldType from "../constants/FieldType";
import {find, removeAll} from "../common/HasIDUtil";
import {toString} from "../common/FieldTypesUtils";
import {currentLoginInfo} from "../login/LoginPresenter";

/**
 *
 * @param {string} dimType
 * @param {namaTypes.DTOHasOverrideDimensionOptions} report
 */
function getOverrideSelectedDimension(dimType,report)
{
    if (areEqual(dimType, DomainBaseEntities.LegalEntity))
        return report.overrideSelectedLegalEntity;
    if (areEqual(dimType, DomainBaseEntities.Sector))
        return report.overrideSelectedSector;
    if (areEqual(dimType, DomainBaseEntities.Department))
        return report.overrideSelectedDepartment;
    if (areEqual(dimType, DomainBaseEntities.Branch))
        return report.overrideSelectedBranch;
    if (areEqual(dimType, DomainBaseEntities.AnalysisSet))
        return report.overrideSelectedAnalysisSet;
    return null;
}
/**
 *
 * @param {string} dimType
 * * @param {namaTypes.EntityReferenceData} dim
 * @param {namaTypes.ReportMetadataContainer} report
 */
function shouldOverride(dimType, dim, report)
{
    let overrideMethod = getOverrideSelectedDimension(dimType, report.reportOverrideOptions);
    if (!overrideMethod)
        overrideMethod = getOverrideSelectedDimension(dimType, report.globalOverrideOptions);
    if (!overrideMethod || areEqual(overrideMethod, OverrideSelectedDimension.Never))
        return false;
    if (areEqual(overrideMethod, OverrideSelectedDimension.Always))
        return true;
    if (areEqual(overrideMethod, OverrideSelectedDimension.WhenNotPublic) && isNotNullDimension(dim))
        return true;
    return false;
}

export function overrideDimensionsIfNeed(filledQuestionFields, report)
{
    for (let questionField of report.metadata.questionFields)
    {
        if ((questionField.fieldType == FieldType.Reference || questionField.fieldType == FieldType.Genericreference) &&
            isAnyEqualToFirst(questionField.metaData.referencedEntityType, DomainBaseEntities.LegalEntity,
                DomainBaseEntities.Sector, DomainBaseEntities.Branch, DomainBaseEntities.Department, DomainBaseEntities.AnalysisSet))
        {
            let filledQuestionField = find(questionField.id, filledQuestionFields);
            let dimType = questionField.metaData.referencedEntityType;
            let dimId = currentLoginInfo().dimensions[dimType];
            if (shouldOverride(dimType, dimId, report) && (!filledQuestionField || isEmptyOrNull(filledQuestionField.value)))
            {
                let overrideValue = {id: questionField.id, value:toString(FieldType.Reference, dimId),objValue:dimId};
                removeAll(overrideValue.id, filledQuestionFields);
                filledQuestionFields.push(overrideValue);
            }
        }
    }
}